import { RouteObject } from "react-router";
import AppExtensionProviderRegistry, { AppExtension, AppExtensionProvider } from "../../framework/app/app.extension.provider";
import ConciergeWelcomePage from "./welcome/concierge.welcome.page";
import { DashboardComponent } from "react-admin";


export const PRODUCT = "concierge";

export class ConciergeAppExtensionProvider implements AppExtensionProvider {
    
    constructor() { 
      console.log('ConciergeAppExtensionProvider: constructor');
      console.log('ConciergeAppExtensionProvider: PRODUCT', PRODUCT);
      AppExtensionProviderRegistry.registerProvider(
        PRODUCT,
        this
      );
    }
    
    getAppExtension(): AppExtension {
      return {
        getAppImage: () => {
            return `./products/${PRODUCT}/banner.png`
        },
        getAppBar: () => {
          return null;
        },
        getMenu: () => {
          return null;
        },
        getRoutes: ():RouteObject[] => {
          const welcome:RouteObject = {
            path: "/welcomeToConciergeAi",
            element: ConciergeWelcomePage
        }
        return [welcome];
        },
        getDefaultRoute: () => {
            return `/welcomeToConciergeAi`;
        },
        getWelcomePage():DashboardComponent {
            return ConciergeWelcomePage;
        },
      };
    }
  }